import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';

import {
    BESIDA_ROLE_BUYER,
    BESIDA_ROLE_COMPANY,
    getRoom
} from '@evo/chat-core';

import {
    getResponseMedianText,
    getC2CUserUrl
} from '../../../../libs/helpers/prom';
import * as a from '../../../../libs/actions';
import * as aggr from '../../../../libs/aggregation';
import * as c from '../../../../libs/constants';
import {
    findObjInArr,
    objectValues,
    getSocketStore,
} from '../../../../libs/utils';

import { toJS } from '../../../helpers/ImmutableToJS';

import { Icon } from '../../../ui/icon';

// styles
import css from './chatHeader.sss';

// images
import CircleInfoIconSvg from './images/circleInfo.icon.svg';



class TitleView extends React.Component {
    static propTypes = {
        isInDialog: PropTypes.bool,
        currentRoomName: PropTypes.any,
        currentChatRoom: PropTypes.any,
        responseMedian: PropTypes.any,
    };

    handleGetCompanyInfo = () => {
        const { currentChatRoom } = this.props;
        const roomExtra = currentChatRoom && currentChatRoom.extra;

        roomExtra && this.props.send(a.EVENT_COMPANY_SHOW_INFO, { ident: roomExtra.company_id });
    }

    handleGetClientInfo = (ident) => {
        return (ev) => {
            ev.preventDefault();
            this.props.send(a.EVENT_CLIENT_SHOW_INFO, { ident });
        };
    }

    render() {
        const {
            currentChatRoom, userRole, isInDialog, currentRoomName, responseMedian
        } = this.props;
        if (!currentRoomName) return null;
        const isInCompanyRole = userRole === BESIDA_ROLE_COMPANY;
        const responseMedianText = !isInCompanyRole && getResponseMedianText(responseMedian);


        // =================== C2C Title ===========================

        const roomExtra = currentChatRoom && currentChatRoom.extra || {};

        if (roomExtra.company_type === c.COMPANY_C2C_TYPE) {
            let user = null;

            if (isInDialog && currentChatRoom.users) {
                user = findObjInArr(
                    objectValues(currentChatRoom.users),
                    (obj) => obj.role === BESIDA_ROLE_COMPANY ? BESIDA_ROLE_BUYER : BESIDA_ROLE_COMPANY
                );
            }
            return (
                <React.Fragment>
                    {user ? (
                        <a
                            className={css.link}
                            href={getC2CUserUrl(user.ident)}
                            target='_blank'
                        >
                            {currentRoomName}
                        </a>
                    ) : (
                        <span>
                            {currentRoomName}
                        </span>
                    )}
                    {!!responseMedian && (
                        <div
                            className={css.median}
                            data-qaid='besida_median_text'
                        >
                            {responseMedianText}
                        </div>
                    )}
                </React.Fragment>
            );
        }

        // =================== B2C Title ===========================


        if (!isInCompanyRole) {
            return (
                <React.Fragment>
                    <span
                        onClick={this.handleGetCompanyInfo}
                        className={css.activeTitle}
                    >
                        {currentRoomName}
                        {/* simlpe hack */}
                        <span className={css.info} data-qaid='company_info_icon'>
                            <Icon className={css.infoIcon} glyph={CircleInfoIconSvg} />
                        </span>
                    </span>
                    {!!responseMedian && (
                        <div
                            className={css.median}
                            data-qaid='besida_median_text'
                        >
                            {responseMedianText}
                        </div>
                    )}
                </React.Fragment>
            );
        }

        // =================== Company Title ===========================

        let buyer = null;

        if (isInDialog && currentChatRoom.users) {
            buyer = findObjInArr(
                objectValues(currentChatRoom.users),
                (obj) => obj.role === BESIDA_ROLE_BUYER
            );
        }

        let headerTitleMarkup = (
            <span>
                {currentRoomName}
            </span>
        );

        if (buyer) {
            headerTitleMarkup = (
                <span
                    data-qaid='client_name'
                    onClick={this.handleGetClientInfo(buyer.ident)}
                    className={css.activeTitle}
                >
                    {currentRoomName}
                    {/* simlpe hack */}
                    <span className={css.info} data-qaid='client_info_icon'>
                        <Icon className={css.infoIcon} glyph={CircleInfoIconSvg} />
                    </span>
                </span>
            );
        }

        return headerTitleMarkup;
    }
}

const mapStateToProps = (state) => {
    const socketStore = getSocketStore(state);
    const currentChatRoom = getRoom(socketStore, state.get('openedRoomIdent'));

    return {
        isInDialog: aggr.isInDialog(currentChatRoom),
        responseMedian: currentChatRoom.get('response_median') || '',
        currentRoomName: currentChatRoom.get('room_name'),
        locale: state.get('locale'),
        userRole: state.get('userRole'),
        currentChatRoom,
    };
};

export const Title = connect(mapStateToProps)(toJS(TitleView));
